import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import SoundAssetKeys from '../SoundAssetKeys';
import TrackBall from './TrackBall';

export default class Shooter extends Phaser.GameObjects.Container {
  constructor(scene) {
    super(scene);
    scene.add.existing(this);

    this.scene = scene;

    this.backPiece = ABCyaPhaser.Images.addImage(0, 0, 'shooter-back', this);

    // this.centerPt = { x: this.backPiece.getBounds().width / 2 - 20, y: this.backPiece.getBounds().height / 2 };
    this.centerPt = { x: 0, y: 0 };
    this.backPiece.setOrigin(.3, .5);

    this.shotOffset = { xOffset: this.centerPt.x + 80,yOffset: this.centerPt.y };

    this.shot = null;
    this.nextShot = null;
    this.shotReady = false;
  }

  pointAt(pointX,pointY) {
    // rotate
    const diffX = pointX - this.x;
    const diffY = pointY - this.y;

    const r = Math.atan2(diffY,diffX) * 180 / Math.PI;
    this.angle = r;
    if (this.shot) this.shot.angle = 360 - r;
    if (this.nextShot) this.nextShot.angle = 360 - r;
  };

  readyNextShot(value,color) {
    if (this.nextShot === null) {
      this.shot = new TrackBall(this.scene, value,color);
      this.add(this.shot);
      this.nextShot = new TrackBall(this.scene, value,color);

      // this.nextShot.visible = false;
    }
    else {
      this.shot = this.nextShot;
      this.nextShot = new TrackBall(this.scene, value,color);

      // this.shot.visible = true;
      // this.nextShot.visible = false;
    }

    // add new ball
    this.nextShot.x = this.centerPt.x;
    this.nextShot.y = this.centerPt.y;
    this.nextShot.alpha = 0;
    this.nextShot.angle = 360 - this.angle;
    this.add(this.nextShot);

    this.shot.angle = 360 - this.angle;

    // tween from cannon
    this.shot.x = this.centerPt.x + 50;
    this.shot.y = this.centerPt.y;
    this.shot.scaleX = 0;
    this.shot.scaleY = 0;
    this.shot.alpha = 0;

    ABCyaPhaser.Tweens.addTween(this.nextShot, 400, { alpha: 1,scaleX: 0.5,scaleY: 0.5 }, Phaser.Math.Easing.Back.Out);
    ABCyaPhaser.Tweens.addTween(this.shot, 500, { alpha: 1,scaleX: 1,scaleY: 1,x: this.shotOffset.xOffset }, Phaser.Math.Easing.Back.Out, () => {
      this.handleShotReady();
    });
  };

  changeShots(val1,c1,val2,c2) {
    if (this.shot) this.shot.changeBall(val1,c1);
    if (this.nextShot) this.nextShot.changeBall(val2,c2);
  };

  handleShotReady() {
    this.shotReady = true;
  };

  shoot() {
    if (this.shotReady === true) {
      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._swish, this.scene);

      this.shotReady = false;
      const a = this.angle;

      this.parentContainer.add(this.shot);

      const firePt = this.getRotatedPoint(a,80);

      this.scene.tweens.killTweensOf(this.shot);
      this.shot.scaleX = 1;
      this.shot.scaleY = 1;
      this.shot.x = this.x + firePt.x;
      this.shot.y = this.y + firePt.y;

      const shotInfo = { ball: this.shot, shotAngle: a };
      this.shot = null;
      return shotInfo;
    }
  };

  getRotatedPoint(rotateAngle, radius) {
    const degToRad = 0.0174532925;
    const px = radius * Math.cos(rotateAngle * degToRad);
    const py = radius * Math.sin(rotateAngle * degToRad);
    const point = { x: px, y: py };
    return point;
  }

  normalize(min, max) {
    const delta = max - min;
    return function (val) {
      return (val - min) / delta;
    };
  }
}